module.exports = __webpack_public_path__ + "media/images/lb/502-31b3cfde59ff7ea301174e2577778bea.svg";